import { createFeatureSelector, createSelector } from '@ngrx/store';

import { COUNTRY_FEATURE_KEY, CountryState, countryAdapter } from './country.reducer';

// Lookup the 'Country' feature state managed by NgRx
export const selectCountryState = createFeatureSelector<CountryState>(COUNTRY_FEATURE_KEY);

const { selectAll, selectEntities } = countryAdapter.getSelectors();

export const selectCountryLoaded = createSelector(
  selectCountryState,
  (state: CountryState) => state.loaded,
);

export const selectCountryError = createSelector(
  selectCountryState,
  (state: CountryState) => state.error,
);

export const selectAllCountry = createSelector(selectCountryState, (state: CountryState) =>
  selectAll(state),
);

export const selectCountryEntities = createSelector(selectCountryState, (state: CountryState) =>
  selectEntities(state),
);

export const selectSelectedId = createSelector(
  selectCountryState,
  (state: CountryState) => state.selectedId,
);

export const selectEntity = createSelector(
  selectCountryEntities,
  selectSelectedId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined),
);

export const selectCountryList = createSelector(selectCountryState, (state: CountryState) => {
  return state.countryList ?? [];
});

export const selectCountyByIsoCode = (isoCode: string) =>
  createSelector(selectCountryState, (state: CountryState) =>
    state.countryList?.find(
      (c) => c.iso_code?.toLocaleLowerCase() === isoCode?.toLocaleLowerCase(),
    ),
  );
export const selectCountyById = (id: number) =>
  createSelector(selectCountryState, (state: CountryState) =>
    state.countryList.find((c) => c.id === id),
  );
